import React from 'react';

const VBSRegistrationTable = ({ list, onDelete }) => {
  return (
    <div className="card">
      <div className="card-body">
        <h3 className="card-title mb-4">VBS Registrations</h3>
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Child Name</th>
                <th>Age</th>
                <th>Parent Name</th>
                <th>Contact Number</th>
                <th>Parent Stays</th>
                <th>Staying Adult</th>
                <th>Food Allergy</th>
                <th>Allergies</th>
                <th>Registration Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {list.map((data, index) => (
                <tr key={index}>
                  {/* Child Full Name */}
                  <td>{data.ChildFullName}</td>

                  {/* Child Age */}
                  <td>{data.ChildAge}</td>

                  {/* Parent Name */}
                  <td>{data.ChildParentName}</td>

                  {/* Contact Number */}
                  <td>{data.ParentContactNumber}</td>

                  {/* Parent Stay With Child */}
                  <td>
                    <span className={`badge ${data.ParentStayWithChild ? 'bg-success' : 'bg-secondary'}`}>
                      {data.ParentStayWithChild ? 'Yes' : 'No'}
                    </span>
                  </td>

                  {/* Parent Stay Name */}
                  <td>{data.ParentStayName || 'N/A'}</td>

                  {/* Food Allergy */}
                  <td>
                    <span className={`badge ${data.HasFoodAllergy ? 'bg-danger' : 'bg-success'}`}>
                      {data.HasFoodAllergy ? 'Yes' : 'No'}
                    </span>
                  </td>

                 {/* Food Allergies List */}
<td>
  {data.HasFoodAllergy && data.FoodAllergies ? (
    <div>
      {(() => {
        // Parse the string if it's JSON, otherwise use as is
        let allergyArray = [];
        try {
          allergyArray = typeof data.FoodAllergies === 'string' 
            ? JSON.parse(data.FoodAllergies) 
            : data.FoodAllergies;
        } catch (e) {
          allergyArray = [];
        }

        return allergyArray.length > 0 ? (
          allergyArray.map((allergy, allergyIndex) => (
            <span
              key={allergyIndex}
              className="badge bg-warning text-dark me-1 mb-1"
              style={{ fontSize: '0.7rem' }}
            >
              {allergy}
            </span>
          ))
        ) : (
          <span>None</span>
        );
      })()}
    </div>
  ) : (
    <div>None</div>
  )}
</td>

                  {/* Registration Date */}
                  <td>{new Date(data.RegistrationDate).toLocaleDateString('en-GB')}</td>

                  {/* Delete Button */}
                  <td>
                    <button
                      disabled
                      onClick={() => onDelete(data)}
                      className="btn btn-danger btn-sm"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default VBSRegistrationTable;